// Components
import { Timeline, BreadCrumb } from '../../components';

import { resetSavedPgs } from '../../containers/MerchantOnboard/redux/pgConfig/pgConfig.actions';
import { setEntityDataSuccess } from '../../containers/MerchantOnboard/redux/editMerchant/editMerchant.actions';
import { onboardingProcess } from './timelineSteps';

// Actions
import { fetchFormInProcessRequest } from './redux/merchantOnBoard.actions';

// Libraries
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const getDraftData = (draftData, sectionType) => {
    const filteredData =
        draftData &&
        draftData.length &&
        draftData.find(section => section.type === sectionType);

    return filteredData;
};

const CreateMerchant = ({ data, actions, draftData, history, permissions }) => {
    const {
        timeline: { fields },
        uniqueIdentifier: { isInEditMode },
    } = data;
    const { location } = history;

    const onBoardSteps = onboardingProcess(
        fields,
        draftData,
        location.pathname,
        data,
        permissions
    );
    const completedSection =
        onBoardSteps && onBoardSteps.filter(item => item.status === 'Complete');
    const lastSelected =
        completedSection.length &&
        completedSection[completedSection.length - 1];

    useEffect(() => {
        // Show dialog on explicit route leave
        actions.resetSavedPgs({});
        actions.setEntityDataSuccess({
            aggregator: '',
            franchise: '',
            mle: '',
        });
        function unloadRoute(event) {
            event.returnValue = 'Changes that you made may not be saved.';
        }

        window.addEventListener('beforeunload', unloadRoute);
        return () => {
            window.removeEventListener('beforeunload', unloadRoute);
        };
    }, [actions]);

    useEffect(() => {
        // Send merchant dashboard when trying to access directly
        if (
            draftData &&
            draftData.length === 0 &&
            location.pathname !== '/mob/create/merchant'
        ) {
            history.replace('/mob');
        }
    }, [draftData, history, location.pathname]);

    useEffect(() => {
        if (!lastSelected) {
            return;
        }
        if (lastSelected.nextPath) {
            history.push(lastSelected.nextPath);
        } else {
            history.push(lastSelected.path);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="create-merchant-wrap" id="create-merchant-section">
            <div className="bread-crumbs">
                <h3>Create merchant</h3>
                <BreadCrumb
                    breadCrumbs={[
                        {
                            name: 'Merchant Onboarding',
                            link: '/mob',
                        },
                        {
                            name: 'Create Merchant',
                            link: '',
                        },
                    ]}
                />
            </div>
            <div className="create-merchant">
                <div className="left-section">
                    <Timeline
                        onboardingProcess={onBoardSteps}
                        isCreate={isInEditMode}
                    />
                </div>
                <div className="right-section">
                    <Switch>
                        {onBoardSteps.map(tab => (
                            <Route exact path={tab.path} key={tab.tabId}>
                                {tab.component({
                                    ...tab,
                                    draftData: getDraftData(
                                        draftData,
                                        tab.sectionType
                                    ),
                                    onBoardSteps,
                                    isInEditMode,
                                    allDraftData: draftData,
                                })}
                            </Route>
                        ))}
                    </Switch>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = ({ loader }) => ({
    loader,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchFormInProcessRequest,
            resetSavedPgs,
            setEntityDataSuccess,
        },
        dispatch
    ),
});

CreateMerchant.propTypes = {
    data: PropTypes.object.isRequired,
    actions: PropTypes.object,
    draftData: PropTypes.array,
    history: PropTypes.object,
    permissions: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateMerchant);
